import axios from './providers/socialAxios';

const chatService = {
    getPosts(page = 1) {
        return axios.get(`/posts/admin/getPostsByCompany?page=${page}&limit=20`);
    },
    getReportedPosts(page = 1) {
        return axios.get(`/posts/admin/getReports?page=${page}&limit=20`);
    },
    deletePost(postId) {
        return axios.delete(`/posts/deletePostAdmin/${postId}`);
    }
}

export default chatService;
